import { render } from "./EndorsementsTrad.vue?vue&type=template&id=7eea27d2"
import script from "./EndorsementsTrad.vue?vue&type=script&lang=js"
export * from "./EndorsementsTrad.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__